import request from '@/utils/request'
let baseURL = '/mall-content';

// 获取广告
export function listAd(data) {
  return request({
    url: '/api/ad/user/v1/listAd',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
adType (string): SYS-平台广告；SHOP-店铺广告 = ['SYS', 'SHOP'],
clientType (string): 终端类型：PC-PC端；H5-H5端；ANDROID-ANDROID端；IOS-IOS端 = ['PC', 'H5', 'ANDROID', 'IOS'],
shopId (integer, optional): 店铺广告时不为空
}
 */



// 获取导航
export function listNav(data) {
  return request({
    url: '/api/nav/user/v1/listNav',
    method: 'post',
    baseURL,
    data
  })
}
/*
 {
clientType (string): 终端类型：PC-PC端；H5-H5端；ANDROID-ANDROID端；IOS-IOS端 = ['PC', 'H5', 'ANDROID', 'IOS'],
navType (integer): 导航类型：1-商城首页 ,
startTime (integer, optional): 上一次调用接口获取的生效时间戳（后台数据有更新时才返回新数据）
}
 */



// 获取导航
export function tipsList(data) {
  return request({
    url: '/api/tips/list',
    method: 'post',
    baseURL,
    data
  })
}

// 获取前端配置
export function getConfig(params) {
  return request({
    url: '/api/config/v1/list',
    method: 'get',
    baseURL,
    params
  })
}

// 招商报名
export function addEnroll(data) {
  return request({
    url: '/Enroll/v1/addEnroll',
    method: 'post',
    baseURL,
    data
  })
}
